import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: "app-fiesta-de-las-madres",
  templateUrl: "./fiesta-de-las-madres.component.html",
  styleUrls: ["./fiesta-de-las-madres.component.scss"]
})
export class FiestaDeLasMadresComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/fiesta-de-las-madres/fiesta-de-las-madres.component.ts